module.exports = __webpack_public_path__ + "media/svg/logo-maxia-symbol-26bdec6e.svg";